export const isTruthyFlag = (value) => value === true || value === 1 || value === "1";

const isEmptyId = (id) => id === null || id === undefined || id === "" || id === "null";

export const findDefaultRating = (ratingData) => {
  const ratings = Array.isArray(ratingData) ? ratingData : [];
  return ratings.find((rating) => isTruthyFlag(rating?.is_default)) || null;
};

export const isRemovedDefaultRating = (owner, ratingId) => {
  const removedId = owner?.removed_default_rating_id;
  if (isEmptyId(removedId) || isEmptyId(ratingId)) return false;
  return String(removedId) === String(ratingId);
};

export const resolveLiveRating = (ratingRef, ratingData) => {
  if (!ratingRef) return null;
  // Template ratings not loaded yet - keep what the line/comment already carries.
  if (!Array.isArray(ratingData)) return ratingRef;
  // A rating that no longer exists in the template's rating_data must not be shown.
  return ratingData.find((rating) => String(rating?.Id) === String(ratingRef.Id)) || null;
};

// The Inspection Details category (is_inspection_details === 1) is informational - its lines hold
// address/weather/people-present style inputs and carry no rating UI at all, so the template
// default must never be applied there. Note 2 is a different category kind and is not affected.
export const isInspectionDetailsCategory = (category) => isTruthyFlag(category?.is_inspection_details);

export const applyDefaultRating = (owner, selectedRatings, ratingData, skipDefaultRating = false) => {
  const selected = (Array.isArray(selectedRatings) ? selectedRatings : [])
    .filter((rating) => rating && !isRemovedDefaultRating(owner, rating.Id))
    .map((rating) => resolveLiveRating(rating, ratingData))
    .filter(Boolean);
  // An explicit selection still resolves - only the implicit default is withheld.
  if (skipDefaultRating) return selected;
  const defaultRating = findDefaultRating(ratingData);
  if (!defaultRating || isRemovedDefaultRating(owner, defaultRating.Id)) return selected;
  const alreadyIncluded = selected.some((rating) => String(rating?.Id) === String(defaultRating.Id));
  return alreadyIncluded ? selected : [...selected, defaultRating];
};

// `category` is optional: without it the default is applied as before.
export const resolveLineRatings = (line, ratingData, category) =>
  applyDefaultRating(line, line?.line_rating_data, ratingData, isInspectionDetailsCategory(category));

export const resolveCommentRatings = (comment, ratingData, category) => {
  const ratingControl = Array.isArray(comment?.comment_input_controls)
    ? comment.comment_input_controls.find((item) => item.type === "Rating")
    : null;
  return applyDefaultRating(comment, ratingControl?.data, ratingData, isInspectionDetailsCategory(category));
};

export const resolveRemovedDefaultRatingId = (selectedRatings, ratingData) => {
  const defaultRating = findDefaultRating(ratingData);
  if (!defaultRating) return null;
  const stillSelected = (Array.isArray(selectedRatings) ? selectedRatings : []).some(
    (rating) => String(rating?.Id) === String(defaultRating.Id)
  );
  if (stillSelected) return null;
  const numericId = Number(defaultRating.Id);
  return Number.isNaN(numericId) ? defaultRating.Id : numericId;
};

export const getTemplateRatingData = (inspectionData, templateId) =>
  inspectionData?.inspectiontemplates?.find((template) => template.template_id === templateId)?.rating_data || [];
